import { z } from 'zod';
import { selectedItemSchema } from '../../shared/types/priced-item';

export const contractDataSchema = z.object({
  name: z.string().min(2, 'Contract name must be at least 2 characters'),
  firstName: z.string().min(2, 'First name must be at least 2 characters'),
  lastName: z.string().min(0, 'Last name must be at least 2 characters'),
  email: z.string().email('Invalid email address'),
  phoneNumber: z
    .string()
    .min(10, 'Phone number must be at least 10 characters'),
  surgeonId: z.string(),
  surgeonDisplayName: z.string().optional(),
  procedures: selectedItemSchema.array(),
  products: selectedItemSchema.array(),
  totalCost: z.number().default(0),
  discount: z.number().default(0),
  subTotal: z.number().default(0),
});

export type ContractData = z.infer<typeof contractDataSchema>;
